import React, { useEffect, useState } from 'react';
import Header from '../../layouts/header';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { userinfo } from '../../api/server';
import { ThreeDots } from 'react-loader-spinner';
import { FiUser, FiMapPin, FiLock, FiArrowLeft, FiEdit2 } from 'react-icons/fi';
import './userProfile.css';

const ProfileCard = ({ title, icon: Icon, fields, className = '' }) => (
    <section className={`profile-info-card ${className}`}>
        <header className="profile-card-heading">
            <span className="profile-card-icon" aria-hidden="true"><Icon /></span>
            <h2>{title}</h2>
        </header>
        <dl className="profile-fields">
            {fields.map(([label, value]) => (
                <div className="profile-field" key={label}>
                    <dt>{label}</dt>
                    <dd>{value}</dd>
                </div>
            ))}
        </dl>
    </section>
);

const UserProfile = () => {
    const userId = useSelector((state) => state.user.user?.data?.id);
    const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
    const [updatedUserData, setUpdatedUserData] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!isLoggedIn || !userId) return;
        let current = true;
        setLoading(true);
        setUpdatedUserData(undefined);
        userinfo(userId).then((res) => {
            if (current) setUpdatedUserData(res?.data?.data);
        }).catch(() => {
            if (current) setUpdatedUserData(undefined);
        }).finally(() => {
            if (current) setLoading(false);
        });
        return () => { current = false; };
    }, [isLoggedIn, userId]);

    const data = updatedUserData;
    return (
        <div className="user-profile-page">
            <Header />
            <main className="profile-main">
                {isLoggedIn && userId ? <>
                    <div className="profile-page-heading">
                        <h1>My Profile</h1>
                    </div>
                    {loading ? <div className="profile-loading" role="status">
                        <ThreeDots height="32" width="72" radius="9" color="#4e9c4b" ariaLabel="Loading profile" wrapperStyle={{ justifyContent: 'center' }} visible />
                    </div> : <>
                        <div className="profile-card-grid">
                            <ProfileCard title="Main Filer Info" icon={FiUser} fields={[
                                ['Name', [data?.firstname, data?.middleinitial, data?.lastname].filter(Boolean).join(' ')],
                                ['Last four digit of SSN', data?.ssn],
                                ['Phone Number', data?.phone],
                                ['Date of Birth', data?.dob ? data.dob.split('T')[0] : 'N/A'],
                            ]} />
                            <ProfileCard title="Contact Info" icon={FiMapPin} fields={[
                                ['Address', data?.addr1], ['City', data?.city],
                                ['State', data?.state], ['Zip Code', data?.zip],
                            ]} />
                            <ProfileCard title="Account Info..." icon={FiLock} className="profile-account-card" fields={[
                                ['Email', data?.email], ['Username', data?.username],
                            ]} />
                        </div>
                        <div className="profile-page-actions">
                            <Link className="profile-button profile-button-secondary" to="/dashboard"><FiArrowLeft aria-hidden="true" /> Go Back</Link>
                            <Link className="profile-button profile-button-primary" to={`/userprofileupdate?id=${data?.id}`}><FiEdit2 aria-hidden="true" /> Edit Profile</Link>
                        </div>
                    </>}
                </> : <h1>Please Login First</h1>}
            </main>
        </div>
    );
};
export default UserProfile;
